import { IDocumentSchema } from '../../repositories/newbuilding-card/entities/newbuilding/DocumentSchema';
import { IApplicationState } from '../../types/redux';

export function getDocuments(state: IApplicationState): IDocumentSchema[] {
  return state.newbuilding.documentation || [];
}
